import React, { useEffect, useState } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import ErrorMessage from 'redesign/components/atoms/error-message'
import { LARGE_TEXT_FIELD_MIN_ROWS } from 'shared/constants'
import { AddCommentButton, TextField } from './styles'
import type { CommentFieldProps } from './types'

const CommentField: React.FC<CommentFieldProps> = ({
  commentFieldLabel,
  isRequired = false,
  placeholder,
  id,
  testId,
  displayComment,
  setDisplayComment,
  value,
  error,
  onChange,
}) => {
  const [autoFocus, setAutofocus] = useState(false)
  const { t } = useFavurTranslation()
  const displayCommentButton = !displayComment && !isRequired
  const input = document.getElementById(id)

  useEffect(() => {
    if (displayCommentButton) return

    setAutofocus(true)
    input?.focus()
  }, [displayCommentButton, input, isRequired])

  return displayCommentButton ? (
    <AddCommentButton
      variant="outlined"
      color="inherit"
      data-testid="toggle-comment-button"
      onClick={() => setDisplayComment?.(true)}
    >
      {t('button.addComment')}
    </AddCommentButton>
  ) : (
    <ErrorMessage hasError={error} errorMessage={t('common.error.required')}>
      <TextField
        id={id}
        error={error}
        value={value}
        onChange={onChange}
        minRows={LARGE_TEXT_FIELD_MIN_ROWS}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        multiline
        placeholder={placeholder}
        label={commentFieldLabel}
        slotProps={{
          inputLabel: {
            shrink: true,
          },
          htmlInput: {
            'data-testid': testId,
          },
        }}
      />
    </ErrorMessage>
  )
}

export default CommentField
